var animationMaps = new WeakMap();

var animationMapKey = function animationMapKey(name) {
  var pseudoElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return "".concat(name, ":").concat(pseudoElement);
};

function getAnimationMap(element) {
  var map = animationMaps.get(element) || new Map();
  animationMaps.set(element, map);
  return map;
}

export { animationMapKey, getAnimationMap };